import { snakeCase, camelCase, reduce } from 'lodash';
import moment from 'moment';

/**
 * parsing url query string to json
 * @param {string} queryString
 */
export const queryStringToJSON = queryString => {
  let CurrentQueryString = queryString;

  if (queryString.indexOf('#') > -1) {
    // eslint-disable-next-line prefer-destructuring
    CurrentQueryString = queryString.split('#')[1];
  }
  const pairs = CurrentQueryString.split('&');
  const result = {};

  pairs.forEach(pair => {
    const CurrentPair = pair.split('=');
    result[CurrentPair[0]] = decodeURIComponent(CurrentPair[1] || '');
  });

  return result;
};

/**
 * parsing readble time
 * @param {unix} UNIX_timestamp
 */
export const timeConverter = UNIX_timestamp => {
  const a = new Date(UNIX_timestamp * 1000);
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  const year = a.getFullYear();
  const month = months[a.getMonth()];
  const date = a.getDate();
  const hour = a.getHours();
  const min = a.getMinutes();
  const sec = a.getSeconds();
  return `${date} ${month} ${year} ${hour} ${min} ${sec}`;
};

/**
 * spliting the ids by regEx
 * @param {string} string
 */
export const getSplitString = string => {
  const splicedArray = string.split(/[ ,.;\n]+/);
  return splicedArray.filter(id => id !== '');
};

/**
 * spliting the ids by space
 * @param {string} string
 */
export const getSplitStringBySpace = string => string.split(/\s\s+/g);

export const convertObjectKeysToKebabCase = obj => {
  const newObj = reduce(
    obj,
    (res, value, key) => {
      const newKey = snakeCase(key);
      // const defaultValue = typeof obj[key] === 'string' ? '' : 0;
      return {
        ...res,
        [newKey]: value,
      };
    },
    {},
  );
  return newObj;
};
export const convertObjectKeysToCamelCase = obj => {
  const newObj = reduce(
    obj,
    (res, value, key) => {
      const newKey = camelCase(key);
      return {
        ...res,
        [newKey]: value || 0,
      };
    },
    {},
  );
  return newObj;
};

export const getEstimationTimeForQCard = (startTimeStamp, liveTime) => {
  const startDate = new Date(startTimeStamp);
  const endDate = new Date();
  const seconds = (endDate.getTime() - startDate.getTime()) / 1000;
  const duration = liveTime - seconds;
  const result = moment.duration(duration * 1000);
  return `${result._data.days ? `${result._data.days}d ` : ''}${
    result._data.hours ? `${result._data.hours}h ` : ''
  }${result._data.minutes}m`;
};

export const getCurrentUtcTime = () => {
  const now = new Date();
  const utc_now = new Date(
    now.getUTCFullYear(),
    now.getUTCMonth(),
    now.getUTCDate(),
    now.getUTCHours(),
    now.getUTCMinutes(),
  );
  return utc_now;
};
export const getUtcTime = date => {
  const utc = new Date(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes(),
  );
  return utc;
};

export const getSignByProfitType = (type, currency) => {
  switch (type) {
    case 1:
      return '%';
    case 2:
      switch (currency) {
        case 'USD':
          return '$';
        case 'EUR':
          return '€';
        case 'GBP':
          return '£';
        case 'CAD':
          return 'C$';
        default:
          return '';
      }
    default:
      return '';
  }
};

export const capitalizeFirst = string => {
  if (typeof string !== 'string') return '';
  return string.charAt(0).toUpperCase() + string.slice(1);
};
